import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import MainLayout from "../../layouts/MainLayout";
import * as S from "./style";
import MoreVertOutlinedIcon from "@mui/icons-material/MoreVertOutlined";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import PanToolOutlinedIcon from "@mui/icons-material/PanToolOutlined";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import { Checkbox, IconButton, TextField } from "@mui/material";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Cloud from "../../assets/images/iconCloud.svg";
import CircularProgress from "@mui/material/CircularProgress";
import ModalDetails from "./components/modalDetails";
import ModalInfo from "./components/modalInfo";
import ModalCheck from "./components/modalCheck";
import Label from "../../components/Label";
import * as XLSX from "xlsx";
import api from "../../services";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

export default function ExecutionPayments() {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [openElem, setOpenElem] = React.useState(null);
  const [modalIsOpenDetails, setModalIsOpenDetails] = React.useState(false);
  const [modalIsOpenInfo, setModalIsOpenInfo] = React.useState(false);
  const [modalIsOpenCheck, setModalIsOpenCheck] = React.useState(false);
  const [paymentExecution, setPaymentExecution] = React.useState([]);
  const [data, setData] = React.useState([]);
  const [selectedDecline, setSelectedDecline] = React.useState("");
  const [loading, setLoading] = React.useState(false);
  const [status, setStatus] = React.useState([]);
  const [body, setBody] = React.useState({
    type: "",
    content: "",
    start: "",
    end: "",
  });
  const [selected, setSelected] = React.useState([]);
  const [dataClear, setDataClear] = React.useState([]);

  const MySwal = withReactContent(Swal);

  const open = Boolean(anchorEl);
  const handleClick = (event, ElementId) => {
    setAnchorEl(event.currentTarget);
    setOpenElem(ElementId);
  };

  const handleClose = () => {
    setOpenElem(null);
    setAnchorEl(null);
  };

  function openModalDetails(row) {
    setData(row);
    setModalIsOpenDetails(true);
    setAnchorEl(null);
  }

  function openModalInfo(status) {
    if (selected < 1) {
      MySwal.fire({
        icon: "error",
        title: "Erro!",
        text: "Selecione pelo menos um item na tabela",
      });
    } else {
      setDataClear([]);

      setStatus(status);
      setModalIsOpenInfo(true);
      setAnchorEl(null);

      paymentExecution.map((item) => {
        if (item.checked === true) {
          setDataClear((oldState) => [...oldState, item]);
        }
      });
    }
  }
  function openModalCheck() {
    setModalIsOpenCheck(true);
    setAnchorEl(null);
  }
  function HandleExport() {
    setLoading(true);
    var wb = XLSX.utils.book_new(),
      ws = XLSX.utils.json_to_sheet(paymentExecution);

    XLSX.utils.book_append_sheet(wb, ws, "MySheet1");

    XLSX.writeFile(wb, "ExecucaodePagamentos.xlsx");
    setLoading(false);
  }

  const handleClickTable = (event, id, name, value) => {
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];

    setPaymentExecution((prevState) => {
      const newState = prevState.map((obj) => {
        if (obj.id === id) {
          if (obj.checked) {
            return { ...obj, checked: false };
          } else {
            return { ...obj, checked: true };
          }
        }
        return obj;
      });
      return newState;
    });

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }
    setSelected(newSelected);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelected = paymentExecution.map((n) => n.id);
      setSelected(newSelected);

      setPaymentExecution((prevState) => {
        const newState = prevState.map((obj) => {
          if (event.target.checked) {
            return { ...obj, checked: true };
          }
        });
        return newState;
      });
    }
    setSelected([]);
    setPaymentExecution((prevState) => {
      const newState = prevState.map((obj) => {
        return { ...obj, checked: false };
      });
      return newState;
    });
  };

  async function getPaymentExecution() {
    try {
      setLoading(true);
      const res = await api.post(
        "v1/gateway/admin/payment-execution/list",
        body
      );
      setPaymentExecution(res.data.data);

      setLoading(false);
    } catch (err) {
      console.log(err);
    }
  }

  async function UpdatePaymentExecution() {
    let body = {
      ids: selected,
      status: status,
      decline_message: "",
    };
    try {
      setLoading(true);
      const res = await api.put(
        "/v1/gateway/admin/payment-execution/status",
        body
      );

      setSelected([]);
      setModalIsOpenCheck(false);
      setLoading(false);
      if (res.data.error === false) {
        MySwal.fire({
          icon: "success",
          title: "Status alterado!",
          confirmButtonText: "ok!",
          preConfirm: () => {
            window.location.reload();
          },
        });
      }

      if (res.data.error === `true`) {
        MySwal.fire({
          icon: "error",
          title: "Erro!",
          text: "Tente novamente...",
        });
      }
    } catch (err) {
      console.log(err);
    }
  }

  const isSelected = (id) => selected.indexOf(id) !== -1;

  React.useEffect(() => {
    getPaymentExecution();
  }, []);

  return (
    <MainLayout title="Execução de pagamentos">
      <S.Header>
        <S.TimeFilter
          onChange={(e) => setBody({ ...body, start: e.target.value })}
        >
          <Label>Data Inicial</Label>
          <TextField
            id="date"
            type="date"
            inputProps={{
              style: {
                padding: 10,
                height: 20,
                marginRight: 10,
              },
            }}
          />
        </S.TimeFilter>
        <S.TimeFilter
          onChange={(e) => setBody({ ...body, end: e.target.value })}
        >
          <Label>Data Final</Label>
          <TextField
            id="date"
            type="date"
            inputProps={{
              style: {
                padding: 10,
                height: 20,
                marginRight: 10,
              },
            }}
          />
        </S.TimeFilter>
        <S.Select onChange={(e) => setBody({ ...body, type: e.target.value })}>
          <option value="" selected>
            Selecionar filtro
          </option>
          <option value="code">Código da transação</option>
          <option value="statustransaction">Status da transação</option>
          <option value="statusfinance">Status financeiro</option>
          <option value="name">Lojista</option>
          <option value="CPF">CPF/CNPJ</option>
          <option value="email">Email</option>
        </S.Select>
        <S.Input
          placeholder="Busque pelo CNPJ"
          onChange={(e) => setBody({ ...body, content: e.target.value })}
        />
        <S.Button disabled={loading} onClick={() => getPaymentExecution()}>
          Pesquisar
        </S.Button>
      </S.Header>

      <S.HeaderButtons>
        <S.ButtonHeader
          /* disabled={selected < 1} */
          onClick={() => openModalInfo("aprovado")}
        >
          <DoneAllIcon></DoneAllIcon>autorizar transações
        </S.ButtonHeader>
        <S.ButtonHeader
          disabled={selected < 1}
          onClick={() => openModalInfo("reprovado")}
        >
          <PanToolOutlinedIcon fontSize="small"></PanToolOutlinedIcon>reprovar
          transações
        </S.ButtonHeader>
        <S.ButtonHeader
          disabled={selected < 1}
          onClick={() => openModalInfo("cancelado")}
        >
          <HighlightOffIcon></HighlightOffIcon>cancelar transações
        </S.ButtonHeader>

        <S.ButtonHeader disabled={loading} onClick={() => HandleExport()}>
          <S.ImgCloud src={Cloud} alt="icon"></S.ImgCloud>download csv
        </S.ButtonHeader>
      </S.HeaderButtons>
      <TableContainer component={Paper}>
        {loading ? (
          <S.ContainerLoading>
            <CircularProgress style={{ color: "#07254f" }} />
          </S.ContainerLoading>
        ) : (
          <Table sx={{ minWidth: 650 }} aria-label="simple table">
            <TableHead sx={{ backgroundColor: "#B2B2B2" }}>
              <TableRow>
                <TableCell padding="checkbox">
                  <Checkbox
                    color="primary"
                    indeterminate={
                      selected.length > 0 &&
                      selected.length < paymentExecution.length
                    }
                    checked={
                      paymentExecution.length > 0 &&
                      selected.length === paymentExecution.length
                    }
                    onChange={handleSelectAllClick}
                    inputProps={{
                      "aria-label": "select all desserts",
                    }}
                  />
                </TableCell>
                <TableCell>Data e Hora</TableCell>
                <TableCell>Código da Transação</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Status Financeiro</TableCell>
                <TableCell>Valor</TableCell>
                <TableCell>Lojista</TableCell>
                <TableCell></TableCell>
              </TableRow>
            </TableHead>
            {/* name, document, email, phone, city, total */}
            <TableBody>
              {paymentExecution.map((paymentExecution) => {
                const isItemSelected = isSelected(paymentExecution.id);
                return (
                  <TableRow
                    key={paymentExecution.id}
                    sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                    onClick={(event) =>
                      handleClickTable(
                        event,
                        paymentExecution.id,
                        paymentExecution.customer.name,
                        paymentExecution.amount
                      )
                    }
                    role="checkbox"
                    tabIndex={-1}
                    selected={isItemSelected}
                  >
                    <TableCell padding="checkbox">
                      <Checkbox
                        color="primary"
                        checked={isItemSelected}
                        inputProps={{
                          "aria-label": "select all desserts",
                        }}
                      />
                    </TableCell>
                    <TableCell component="th" scope="row">
                      {paymentExecution.date}
                    </TableCell>
                    <TableCell>{paymentExecution.transaction_code}</TableCell>
                    <TableCell>
                      <S.Icon
                        status={paymentExecution.financial_statement_status}
                      >
                        <S.TextIcon
                          status={paymentExecution.financial_statement_status}
                        >
                          {paymentExecution.financial_statement_status}
                        </S.TextIcon>
                      </S.Icon>
                    </TableCell>
                    <TableCell>
                      <S.Icon
                        status={paymentExecution.payment_execution_status}
                      >
                        <S.TextIcon
                          status={paymentExecution.payment_execution_status}
                        >
                          {paymentExecution.payment_execution_status}
                        </S.TextIcon>
                      </S.Icon>
                    </TableCell>
                    <TableCell>
                      {new Intl.NumberFormat("pt-BR", {
                        style: "currency",
                        currency: "BRL",
                      }).format(paymentExecution.amount)}
                    </TableCell>
                    <TableCell>{paymentExecution.customer.name}</TableCell>
                    <TableCell>
                      <IconButton
                        aria-label="more"
                        id="long-button"
                        aria-controls={open ? "long-menu" : undefined}
                        aria-expanded={open ? "true" : undefined}
                        aria-haspopup="true"
                        onClick={(e) => handleClick(e, paymentExecution.id)}
                        style={{ padding: 0 }}
                      >
                        <MoreVertOutlinedIcon />
                      </IconButton>
                      <Menu
                        id={"basic-menu" + paymentExecution.id}
                        anchorEl={anchorEl}
                        open={openElem === paymentExecution.id}
                        onClose={handleClose}
                        anchorOrigin={{
                          vertical: "top",
                          horizontal: "left",
                        }}
                        transformOrigin={{
                          vertical: "top",
                          horizontal: "left",
                        }}
                      >
                        <MenuItem
                          onClick={() => {
                            openModalDetails(paymentExecution);
                            handleClose();
                          }}
                        >
                          Detalhes da transação
                        </MenuItem>
                      </Menu>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        )}
      </TableContainer>

      <ModalDetails
        setModalIsOpenDetails={setModalIsOpenDetails}
        modalIsOpen={modalIsOpenDetails}
        data={data}
      />
      <ModalInfo
        setModalIsOpenInfo={setModalIsOpenInfo}
        modalIsOpenInfo={modalIsOpenInfo}
        setModalIsOpenCheck={setModalIsOpenCheck}
        status={status}
        selected={selected}
        dataClear={dataClear}
        selectedDecline={selectedDecline}
        setSelectedDecline={setSelectedDecline}
      />
      <ModalCheck
        setModalIsOpenCheck={setModalIsOpenCheck}
        modalIsOpenCheck={modalIsOpenCheck}
        UpdatePaymentExecution={UpdatePaymentExecution}
      />
    </MainLayout>
  );
}
